/**
 * Utility per la formattazione delle date in formato italiano GG/MM/AAAA
 */

/**
 * Formatta una data in formato italiano GG/MM/AAAA
 * @param {string|Date} dateInput - Data in formato ISO, YYYY-MM-DD o oggetto Date
 * @returns {string} Data formattata in GG/MM/AAAA o stringa vuota se non valida
 */
export const formatDateIT = (dateInput) => {
  if (!dateInput) return '';
  
  // Se è una stringa vuota o 'N/A', ritorna vuoto
  if (dateInput === '' || dateInput === 'N/A') return '';
  
  try {
    // Gestisci il caso di data già in formato GG/MM/AAAA
    if (typeof dateInput === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateInput)) {
      return dateInput;
    }
    
    // Crea oggetto Date
    const date = new Date(dateInput);
    
    // Verifica che la data sia valida
    if (isNaN(date.getTime())) return '';
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch {
    return '';
  }
};

/**
 * Formatta una data con ora in formato italiano GG/MM/AAAA HH:mm
 * @param {string|Date} dateInput - Data in formato ISO o oggetto Date
 * @returns {string} Data e ora formattate
 */
export const formatDateTimeIT = (dateInput) => {
  if (!dateInput) return '';
  
  try {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return '';
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch {
    return '';
  }
};

/**
 * Converte una data da formato italiano a ISO (YYYY-MM-DD)
 * @param {string} dateIT - Data in formato GG/MM/AAAA
 * @returns {string} Data in formato ISO YYYY-MM-DD o stringa vuota
 */
export const dateITtoISO = (dateIT) => {
  if (!dateIT) return '';
  
  // Se è già in formato ISO, ritorna così
  if (/^\d{4}-\d{2}-\d{2}/.test(dateIT)) {
    return dateIT.substring(0, 10);
  }
  
  const parts = dateIT.split('/');
  if (parts.length !== 3) return '';
  
  const [day, month, year] = parts;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

/**
 * Ottiene la data odierna in formato ISO (YYYY-MM-DD)
 * @returns {string}
 */
export const getTodayISO = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const day = today.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Ottiene la data odierna in formato italiano (GG/MM/AAAA)
 * @returns {string}
 */
export const getTodayIT = () => {
  return formatDateIT(new Date());
};
